module.exports = __webpack_public_path__ + "static/media/logo_blanc.58b8311c.png";